"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return getPaths;
    }
});
const _paths = require("./templates/paths");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function getPaths(context, { base, model, columns, views, tableName }, _ncMeta = _Noco.default.ncMeta) {
    const swaggerPaths = await (0, _paths.getModelPaths)(context, {
        tableName,
        tableId: model.id,
        type: model.type,
        orgs: 'v1',
        columns,
        baseName: base.id
    });
    for (const { view, columns: viewColumns } of views){
        const swaggerColumns = columns.filter((c)=>{
            var _viewColumns_find;
            return (_viewColumns_find = viewColumns.find((vc)=>vc.fk_column_id === c.column.id)) == null ? void 0 : _viewColumns_find.show;
        });
        Object.assign(swaggerPaths, await (0, _paths.getViewPaths)(context, {
            tableName,
            tableId: model.id,
            viewName: view.title,
            viewId: view.id,
            type: model.type,
            orgs: 'v1',
            columns: swaggerColumns,
            baseName: base.id
        }));
    }
    return swaggerPaths;
}
